{
  "valid": "Geldig"
}
